function nameToSlug(category) {
  return category && category.replace(/ &amp; /g, '-').replace(/ & /g, '-').replace(/ /g, '-').toLowerCase();
}
function nameToClass(category) { // hyphens- to camelCase
  return nameToSlug(category).replace(/-([a-z])/g, g => {
    return g[1].toUpperCase();
  });
}
function slugToClass(category) { // hyphens- to camelCase
  return category && category.replace(/-([a-z])/g, g => {
    return g[1].toUpperCase();
  });
}

module.exports = {
  nameToSlug,
  nameToClass,
  slugToClass
};
